"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dom_queries_1 = require("./dom-queries");
/**
 * @hidden
 */
exports.HEADER_CLASS = 'k-grid-header';
/**
 * @hidden
 */
exports.FOOTER_CLASS = 'k-grid-footer';
var TABLE = 'TABLE';
var matchesTable = dom_queries_1.matchesNodeName(TABLE);
/**
 * @hidden
 */
var GridQuery = /** @class */ (function () {
    function GridQuery(element) {
        this.element = element;
        this.list = dom_queries_1.findElement(element, dom_queries_1.matchesClasses("k-grid"));
    }
    GridQuery.prototype.content = function () {
        return dom_queries_1.findElement(this.list, dom_queries_1.matchesClasses("k-grid"));
    };
    GridQuery.prototype.header = function () {
        this.headerWrap = this.headerWrap || dom_queries_1.findElement(this.element, dom_queries_1.matchesClasses(exports.HEADER_CLASS));
        return dom_queries_1.findElement(this.headerWrap, dom_queries_1.matchesClasses("" + exports.HEADER_CLASS));
    };
    GridQuery.prototype.footer = function () {
        this.footerWrap = this.footerWrap || dom_queries_1.findElement(this.element, dom_queries_1.matchesClasses(exports.FOOTER_CLASS));
        return dom_queries_1.findElement(this.footerWrap, dom_queries_1.matchesClasses("" + exports.FOOTER_CLASS));
    };
    GridQuery.prototype.table = function () {
        return dom_queries_1.findElement(this.element, matchesTable);
    };
    return GridQuery;
}());
exports.GridQuery = GridQuery;
//# sourceMappingURL=table-query.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-react-pdf/dist/npm/common/table-query.js
// module id = 835
// module chunks = 0